/**
 * Ð¡Ð½Ð¸Ð¼Ð¾Ðº Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð² â ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð´Ð¸ Ð¿Ð¾Ð´Ð¿Ð¸ÑÐµÐ¹.
 *
 * ÐÑÑÐ¾ÑÐ½Ð¸Ðº Ð¿ÑÐ°Ð²Ð´Ñ Ð¿Ð¾ ÑÐ¸Ð»ÑÑÑÐ°Ð¼ Ð¾Ð´Ð¸Ð½: Ð°Ð´ÑÐµÑÐ½Ð°Ñ ÑÑÑÐ¾ÐºÐ°. ÐÐ¾ Ð² Ð½ÐµÐ¹ Ð»ÐµÐ¶Ð°Ñ id, Ð° Ð² Ð¿Ð¾Ð»Ðµ
 * Ð¸ Ð² ÑÑÑÐ¾ÐºÐµ Ð¿ÑÐ¸Ð¼ÐµÐ½ÑÐ½Ð½ÑÑ ÑÐ¸Ð»ÑÑÑÐ¾Ð² Ð´Ð¾Ð»Ð¶Ð½Ð¾ Ð±ÑÑÑ Â«ÐÐ»Ð¸ÐµÐ½Ñ: ÐÐ²Ð°Ð½ ÐÐ²Ð°Ð½Ð¾Ð²Â», Ð° Ð½Ðµ
 * Â«ÐÐ»Ð¸ÐµÐ½Ñ: 123Â». ÐÐ¾Ð´Ð¿Ð¸ÑÐ¸ Ð±ÐµÑÑÐ¼ Ð¸Ð· ÑÐ½Ð¸Ð¼ÐºÐ° Ð¿Ð¾ÑÐ»ÐµÐ´Ð½ÐµÐ³Ð¾ Ð¿ÑÐ¸Ð¼ÐµÐ½ÐµÐ½Ð¸Ñ; Ð½ÐµÑ ÑÐ½Ð¸Ð¼ÐºÐ°
 * (Ð´ÑÑÐ³Ð°Ñ Ð²ÐºÐ»Ð°Ð´ÐºÐ°, ÑÑÐ¶Ð°Ñ ÑÑÑÐ»ÐºÐ°) â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÐºÐ°Ðº ÐµÑÑÑ.
 *
 * sessionStorage, Ð° Ð½Ðµ localStorage: ÑÐ¸Ð»ÑÑÑÑ Ð¶Ð¸Ð²ÑÑ ÑÐ¾Ð²Ð½Ð¾ ÑÑÐ¾Ð»ÑÐºÐ¾, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð²ÐºÐ»Ð°Ð´ÐºÐ°.
 */
const storageKey = (name) => `filters:${name}`;

export const saveFilterSnapshot = (name, options) => {
  try {
    const snapshot = options
      .filter((option) => option.value !== undefined && option.value !== null && option.value !== '')
      .map((option) => ({ name: option.name, value: option.value }));
    sessionStorage.setItem(storageKey(name), JSON.stringify(snapshot));
  } catch (error) {
    // ÐÑÐ¸Ð²Ð°ÑÐ½ÑÐ¹ ÑÐµÐ¶Ð¸Ð¼ Ð¸Ð»Ð¸ Ð·Ð°Ð±Ð»Ð¾ÐºÐ¸ÑÐ¾Ð²Ð°Ð½Ð½Ð¾Ðµ ÑÑÐ°Ð½Ð¸Ð»Ð¸ÑÐµ â Ð¿ÐµÑÐµÐ¶Ð¸Ð²ÑÐ¼ Ð±ÐµÐ· Ð¿Ð¾Ð´Ð¿Ð¸ÑÐµÐ¹.
  }
};

export const clearFilterSnapshot = (name) => {
  try {
    sessionStorage.removeItem(storageKey(name));
  } catch (error) {
    // ÑÐ¼. Ð²ÑÑÐµ
  }
};

/**
 * ÐÐ½Ð°ÑÐµÐ½Ð¸Ñ Ð´Ð»Ñ Ð¿Ð¾Ð»ÐµÐ¹ ÑÐ¾ÑÐ¼Ñ: Ð¸Ð· ÑÐ½Ð¸Ð¼ÐºÐ°, ÐµÑÐ»Ð¸ Ð¾Ð½ Ð¿ÑÐ¾ ÑÐ¾ Ð¶Ðµ ÑÐ°Ð¼Ð¾Ðµ, Ð¸Ð½Ð°ÑÐµ ÑÑÑÑÐµ Ð¸Ð· Ð°Ð´ÑÐµÑÐ°.
 */
export const readFilterValues = (name, urlFilters = {}) => {
  let snapshot = [];
  try {
    snapshot = JSON.parse(sessionStorage.getItem(storageKey(name)) || '[]');
  } catch (error) {
    snapshot = [];
  }

  const values = {};
  Object.entries(urlFilters).forEach(([field, raw]) => {
    const saved = snapshot.find?.((item) => item.name === field)?.value;
    const sameValue =
      saved !== null && typeof saved === 'object'
        ? String(saved?.value) === String(raw)
        : String(saved) === String(raw);
    values[field] = saved !== undefined && sameValue ? saved : raw;
  });

  return values;
};
